<template>
  <div class="mb-4">

    <!--#region -- Content ---->
    <!--#region SFDC Synchronization Real Data-->
    <div class="">
      <div class="caption-label d-flex" v-if="sfdcProducts">
        <div>
          <b-badge style="margin-right: 10px;" v-if="sfdcProducts" variant="primary">{{sfdcProducts.length}}</b-badge>
          SFDC Synchronization
        </div>
      </div>
      <!--
      <div v-if="updateErrMsg !== null && updateErrMsg !== '' ">
        <b-alert show variant="danger" dismissible>
          {{updateErrMsg}}
        </b-alert>
      </div>
    -->
      <div style="padding-top: 10px;" v-if="basicInfo !== null && basicInfo.device !== null">
        <b-form-checkbox v-model="fixModel"
                         name="check-button"
                         @change="fixModelforPrdLine(fixModel)"
                         switch>
          Restrict SKUs for model {{basicInfo.device}}: <b>{{ fixModel }}</b>
        </b-form-checkbox>
      </div>

      <div class="table-responsive" style="padding-top: 10px;" v-if="sfdcProducts">
        <b-table :fields="sfdcProductFields" :items="sfdcProducts"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>



          <template #cell(custom_level_result)="data">
            <!-- <div v-if="data.item.customization_pn_set !== null && _.size(data.item.customization_pn_set)>0">-->
            <div>
              <div class="row mb-2">
                <div v-if="data.item.custom_level_result_in_short != null && _.trim(data.item.custom_level_result_in_short) !== ''" class="col">
                  <div style="margin-left: 1.1rem;">{{data.item.custom_level_result_in_short}}</div>
                </div>
                <div v-else class="col">
                  <div style="margin-left: 1.1rem;">
                    <div>{{noneSelectedHint}}</div>
                  </div>
                </div>
                <div class="col-3">
                  <div v-if="actionEnable && (userSites !==null && userSites.includes('Getac'))">
                    <button type="button"
                            class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                            style="margin-top: 0.5rem; margin-left: -1.5rem;"
                            @click="getCustomCategoryList(data.item)"></button>
                  </div>
                </div>
              </div>
            </div>
            <!--<div v-else>
            <span style="font-size: small; color: gray; padding-left: 15px; font-style: italic;">
              {{maintianPnHint}}
            </span>
          </div>-->
          </template>


          <!-- region: unique_pn.critical_pn _.size(data.item.nre_quotes-->
          <template #cell(unique_pn)="data">
            <div v-if="actionEnable && (userSites !==null && userSites.includes('Getac')) && data.item.customization_pn_set !== null && _.size(data.item.customization_pn_set)>0">
              <div class="row mb-2">
                <div class="col-8">
                  <!----------------------------size == 0 ------------------------->
                  <div v-if="data.item.unique_pn === null || _.size(data.item.unique_pn)===0">
                    <div></div>
                  </div>
                  <!----------------------------size <= 2 ------------------------->
                  <div v-else-if="_.size(data.item.unique_pn)<3">
                    <div v-for="pn, index in data.item.unique_pn" :key="index">
                      <div v-if="pn != null">
                        <div>{{ pn.critical_pn }}</div>
                      </div>
                    </div>
                  </div>
                  <!----------------------------size > 2 ------------------------->
                  <div v-else>
                    <div v-if="data.item.unique_pn[0] != null">{{ data.item.unique_pn[0].critical_pn }}</div>
                    <div v-if="data.item.unique_pn[1] != null">{{ data.item.unique_pn[1].critical_pn }}</div>
                    <!-- collapseUniquePn

                                                          <b-button v-b-toggle="'collapseUniquePn'"
                                              style="background-color:transparent; border: none">...</b-button>

                                    <b-collapse id="collapseUniquePn">
                                      <div v-for="pn, index in data.item.unique_pn" :key="index">
                                        <div v-if="pn != null && index > 1">
                                          {{pn.critical_pn}}
                                        </div>
                                      </div>
                                    </b-collapse>

                  -->

                  </div>
                </div>
                <div class="col-2">
                  <div v-if="actionEnable">
                    <button type="button"
                            class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                            style="margin-top: 0.5rem; margin-left: -1.5rem;"
                            @click="showEditUniquePnModal(data.item)"></button>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <span style="font-size: small; color: gray; padding-left: 15px; font-style: italic;">
                {{maintianPnHint}}
              </span>
            </div>
          </template>
          <!-- endregion-->
          <!-- remark this area, this is for change the table head style, using form radio that user choose view P/N for standard or customization -->
          <!--
                    <template #head(customization_pn_set)="data">

                      <b-form-group label="P/N for" label-cols-lg="2" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group v-model="fixCustomizationPn"
                                            :aria-describedby="ariaDescribedby"
                                            class="mt-lg-2">
                          <b-form-radio value="Customization" inline>Customization</b-form-radio>
                          <b-form-radio value="Standard" inline>Standard</b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>

                    </template>
        -->
          <!---->
          <template #cell(standard_pn)="data">
            <div>
              <div v-if="data.item.std_pn_set === null || _.size(data.item.std_pn_set) === 0">
                <div class="row mb-2">
                  <div class="col-2">
                    <div>MPS</div>
                    <div>SHIP</div>
                  </div>
                  <div class="col-8">
                    <div>: </div>
                    <div>: </div>
                  </div>
                </div>
              </div>
              <div v-else v-for="customization_pn_obj, index in data.item.std_pn_set" :key="index">
                <div v-if="customization_pn_obj != null">
                  <div class="row mb-2" v-if="customization_pn_obj !== null">
                    <div class="col-2">
                      <div>MPS</div>
                      <div>SHIP</div>
                    </div>
                    <div class="col-8">
                      <div>: {{ customization_pn_obj.mps_pn }}</div>
                      <div>: {{ customization_pn_obj.ship_pn }}</div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row mb-2">
                    <div class="col-2">
                      <div>MPS</div>
                      <div>SHIP</div>
                    </div>
                    <div class="col-8">
                      <div>: </div>
                      <div>: </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template #cell(customization_pn_set)="data">
            <div v-if="fixCustomizationPn === 'Standard'">
              <div v-if="data.item.std_pn_set === null || _.size(data.item.std_pn_set) === 0">
                <div class="row mb-2">
                  <div class="col-2">
                    <div>MPS</div>
                    <div>SHIP</div>
                  </div>
                  <div class="col-8">
                    <div>: </div>
                    <div>: </div>
                  </div>
                  <div class="col-2">
                    <div v-if="actionEnable && (userSites !==null && userSites.includes('Getac'))">
                      <button type="button"
                              class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                              style="margin-top: 0.5rem; margin-left: -1.5rem;"
                              @click="showCustomPnSyncModal(data.item)"></button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else v-for="customization_pn_obj, index in data.item.std_pn_set" :key="index">
                <div v-if="customization_pn_obj != null">
                  <div class="row mb-2"
                       v-if="!checkPnEligible( _.get(customization_pn_obj, 'mps_pn', '')) || !checkPnEligible( _.get(customization_pn_obj, 'ship_pn', ''))">
                    <b-badge style="margin-left: 15px" variant="warning">{{tempPnTag}}</b-badge>
                  </div>
                  <div class="row mb-2" v-if="customization_pn_obj !== null">
                    <div class="col-2">
                      <div>MPS</div>
                      <div>SHIP</div>
                    </div>
                    <div class="col-8">
                      <div>: {{ customization_pn_obj.mps_pn }} </div>
                      <div>: {{ customization_pn_obj.ship_pn }}</div>
                    </div>
                    <div class="col-2">
                      <div v-if="actionEnable">
                        <button type="button"
                                class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                                style="margin-top: 0.5rem; margin-left: -1.5rem;"
                                @click="showCustomPnSyncModal(data.item)"></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row mb-2">
                    <div class="col-2">
                      <div>MPS</div>
                      <div>SHIP</div>
                    </div>
                    <div class="col-8">
                      <div>: </div>
                      <div>: </div>
                    </div>
                    <div class="col-2">
                      <div v-if="actionEnable">
                        <button type="button"
                                class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                                style="margin-top: 0.5rem; margin-left: -1.5rem;"
                                @click="showCustomPnSyncModal(data.item)"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="data.item.customization_pn_set === null || _.size(data.item.customization_pn_set) === 0">
                <div class="row mb-2">
                  <div class="col-2">
                    <div>MPS</div>
                    <div>SHIP</div>
                  </div>
                  <div class="col-8">
                    <div>: </div>
                    <div>: </div>
                  </div>
                  <div class="col-2">
                    <div v-if="actionEnable">
                      <button type="button"
                              class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                              style="margin-top: 0.5rem; margin-left: -1.5rem;"
                              @click="showCustomPnSyncModal(data.item)"></button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else v-for="customization_pn_obj, index in data.item.customization_pn_set" :key="index">
                <div v-if="customization_pn_obj != null">
                  <div class="row mb-2" v-if="!checkPnEligible( _.get(customization_pn_obj, 'mps_pn', '')) || !checkPnEligible( _.get(customization_pn_obj, 'ship_pn', ''))">
                    <b-badge style="margin-left: 15px" variant="warning">{{tempPnTag}}</b-badge>
                  </div>
                  <div class="row mb-2" v-if="customization_pn_obj !== null">
                    <div class="col-2">
                      <div>MPS</div>
                      <div>SHIP</div>
                    </div>
                    <div class="col-8">
                      <div>: {{ customization_pn_obj.mps_pn }}</div>
                      <div>: {{ customization_pn_obj.ship_pn }}</div>
                    </div>
                    <div class="col-2">
                      <div v-if="actionEnable">
                        <button type="button"
                                class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                                style="margin-top: 0.5rem; margin-left: -1.5rem;"
                                @click="showCustomPnSyncModal(data.item)"></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row mb-2">
                    <div class="col-2">
                      <div>MPS</div>
                      <div>SHIP</div>
                    </div>
                    <div class="col-8">
                      <div>: </div>
                      <div>: </div>
                    </div>
                    <div class="col-2">
                      <div v-if="actionEnable">
                        <button type="button"
                                class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                                style="margin-top: 0.5rem; margin-left: -1.5rem;"
                                @click="showCustomPnSyncModal(data.item)"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </template>
          <template #cell(sfdc_cust_pn_set)="data">
            <div class="row mb-2">
                  <div class="col-2">
                    <div>MPS</div>
                    <div>SHIP</div>
                  </div>
                  <div class="col-8">
                    <div>: {{data.item.mps_cust_pn}}</div>
                    <div>: {{data.item.mps_cust_ship_pn}}</div>
                  </div>
                </div>
          </template>
          <template #cell(mps_ftie_id)="data">
            <div class="d-flex align-items-center">
              <div class="mt-1 ml-2">{{data.item.mps_ftie_id}}</div>
                <div v-if="actionEnable">
                  <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                  @click="showSyncFtieOnlyModal(data.item)"></button>
                </div>
            </div>
          </template>
        </b-table>
      </div>

    </div>
    <!--#endregion-->
    <!--#region --  Edit custom level Modal ---->
    <b-modal centered size="lg"
             :ok-title="`Save`"
             @ok="saveCustomLevel(customlevelModalData)"
             ref="customLevelModal"
             :title="`Edit Custom Level for PN ${customlevelModalData.shippedPnToSync}`"
             button-size="sm">
      <div class="header-col" v-if="displayCustomFinalResult && displayCustomFinalResult !== '' ">
        <div>Saved Result</div>
        <div class="flex-fill">
          <span>{{displayCustomFinalResult}}</span>
        </div>
      </div>

      <div v-if="customCategoryList" style="padding-top: 0px;">
        <b-form-group label="Edit Preview"
                      class="header-col">
          <div style="padding-bottom: 10px;">
            <strong>{{displayCustomWeight}}</strong>
          </div>
          <b-form-checkbox v-for="option in customCategoryList"
                           v-model="selectedCategory"
                           @change="tickCustomCategory"
                           :key="option.description"
                           :value="option.description"
                           name="flavour-3a"
                           stack>
            {{ option.description }}
          </b-form-checkbox>
        </b-form-group>
      </div>
    </b-modal>
    <!-- #enregion Modal -->
    <!--#region --  Edit Unique Compo. PN Modal ---->
    <b-modal hide-footer centered size="lg"
             ref="uniquePnModal"
             :title="`Edit Unique Components for PN ${uniquePnModalData.shippedPnToSync}`"
             button-size="sm">
      <div class="header-col">
        <div>Add Unique Compo P/N</div>
        <div class="flex-fill">
          <div class="flex-wrap">
            <div class="w-100">
              <textarea class="w-100" v-model="uniqueCompoPnToAdd"></textarea>
            </div>
          </div>
        </div>
        <div v-if="actionEnable" style="padding-left: 10px;">
          <button type="button" class="btn btn-primary btn-sm min-w-4"
                  @click="addUniquePn(uniquePnModalData)">
            Add
          </button>
        </div>

      </div>

      <div v-if="uniquePnModalData !== null && _.get(uniquePnModalData, 'errorMsg', null) !== null && _.get(uniquePnModalData, 'errorMsg', null) !== ''" class="row mb-2">
        <div class="col-12">
          <b class="text-danger pl-1">* Update {{_.get(uniquePnModalData, 'errorMsg', null)}}</b>
        </div>

      </div>

      <div class="header-col">
        <div v-if="uniquePnModalData!==null && uniquePnModalData.uniquePnList!==null && uniquePnModalData.uniquePnList!==''"
             class="d-flex">
          <div class="h5 font-weight-bold">{{ _.size(uniquePnModalData.uniquePnList) }} Unique PN</div>
        </div>
      </div>
      <div class="header-col"
           v-if="uniquePnModalData!==null && uniquePnModalData.uniquePnList!==null && uniquePnModalData.uniquePnList!=='' && _.size(uniquePnModalData.uniquePnList)>0">

        <b-table striped hover :items="uniquePnModalData.uniquePnList" :fields="uniquePnTableFields">
          <template #cell(action)="data">
            <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete" @click="deleteUniquePn(uniquePnModalData, data.item.critical_pn)"></button>
          </template>
        </b-table>
      </div>
    </b-modal>
    <!-- #enregion Modal-->
    <!-- #region -- Edit Customization Ship/MPS PN Modal -->
    <!-- #region -- Add/Maintain MPS, SHIP, TAA PN in Table 2                         size="sm" -->
    <b-modal centered
             ok-title="Save"
             @ok="validatePrdLineForSync() && validatePartNumberFormat(customizationPnModalData) && saveCustomizationPn(customizationPnModalData)"
             ref="customizationPnModal"
             title="Add/Edit Customization PN"
             button-size="sm">
      <!-- @ok="validatePrdLineForSync() && validatePartNumberFormat(customizationPnModalData) && saveCustomizationPn(customizationPnModalData)"-->
      <div style="padding-top: 1rem;"
           v-if="customizationPnModalData && customizationPnModalData.shippedPnToSync
                     && (customizationPnModalData.shippedPnToSync === ''
           || customizationPnModalData.shippedPnToSync === 'N/A')">
        <span>Please add P/Ns for the following.</span>
      </div>

      <br />

      <div class="header-col">
        <div class="col-6"><b>Standard SKU ID</b></div>
        <div class="col">{{_.get(customizationPnModalData, 'refSkuId', '')}}</div>
      </div>

      <div class="header-col">
        <div class="col-6"><b>Standard MPS P/N</b></div>
        <div class="col">{{_.get(customizationPnModalData, 'mpsPnStd', '')}}</div>
      </div>
      <div class="header-col">
        <div class="col-6"><b>Standard SHIP P/N</b></div>
        <div class="col">{{_.get(customizationPnModalData, 'shipPnStd', '')}}</div>
      </div>
      <div class="border-bottom" style="padding-top: 1rem;"></div>
      <br />
      <div class="header-col">
        <div class="col-6"><b>Customization MPS P/N</b><span class="text-danger pl-1">*</span></div>
        <div>
          <gtc-text-box :readOnly="false" class="form-control form-control-sm" required
                        v-model="customizationPnModalData.mpsPnToSyncNew" />
          <div class="invalid-feedback">
            {{ _.get(customizationPnModalData, 'mpsPnToSyncNew', '') == '' ? 'Please enter P/N accordingly' : 'Please enter P/N accordingly.'  }}
          </div>
        </div>
      </div>
      <div class="header-col">
        <div class="col-6"><b>Customization SHIP P/N</b><span class="text-danger pl-1">*</span></div>
        <!--v-if="mpsShipTaaPnModal && mpsShipTaaPnModal.customShipPn"-->
        <div>
          <gtc-text-box :readOnly="false" class="form-control form-control-sm" required
                        v-model="customizationPnModalData.shippedPnToSyncNew" />
          <div class="invalid-feedback">
            {{ _.get(customizationPnModalData, 'shippedPnToSyncNew', '') == '' ? 'Please enter P/N accordingly' : 'Please enter P/N accordingly.'  }}
          </div>
        </div>
      </div>
      <div class="header-col">
        <div class="col-6">
          <b>Has Autopilot Request</b>
          <span class="text-danger pl-1">*</span>
        </div>
        <div>
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio-group v-model="customizationPnModalData.confirmAutopilotReq"
                                :aria-describedby="ariaDescribedby"
                                :options="autopilotOptions"
                                name="autopilot-radio">
            </b-form-radio-group>
            <b-form-invalid-feedback :state="autopilotFlagState">
              * Different choice from original ES, SA <span style="font-weight:bold">{{hasOrNotTickAutopilot}} </span>
              ticked the Autopilot Flag
            </b-form-invalid-feedback>
            <!--
        <b-form-valid-feedback :state="autopilotFlagState">Same input from SA</b-form-valid-feedback>
            -->

          </b-form-group>
        </div>
      </div>
      <div class="header-col">
        <div class="col-6">
          <b>NRE ID</b>
          <span class="text-danger pl-1">*</span>
        </div>
        <div>
          <b-form-select v-model="customizationPnModalData.nre_id"
                         :options="customizationPnModalData.nre_list">

          </b-form-select>
        </div>
      </div>
      <div v-if="customizationPnModalData.sfdcPrdLines!== null && _.size(customizationPnModalData.sfdcPrdLines)>1">
        <div class="border-bottom" style="padding-top: 1rem;"></div>
        <br />
        <div class="row mb-2">
          <div class="col-12">
            <span class="text-danger pl-1">There are multiple product line in SFDC shared the same standard SKU ID and Qty. Please confirm if need to sync them all.</span>
          </div>
        </div>
        <br />
        <div class="row mb-2" style="margin:1.5px">
          <b-form-group>
            <b-form-checkbox v-model="checkAll"
                             @change="onCheckAllChange">
              All
            </b-form-checkbox>
            <b-form-checkbox v-for="sfdcPrdLine in customizationPnModalData.sfdcPrdLines"
                             v-model="selectedMpsIdToSync"
                             :key="sfdcPrdLine.mps_id"
                             :value="sfdcPrdLine.mps_id"
                             name="flavour-3a"
                             stack>
              <!--                             @change="setPnWarning"-->
              ID: {{ sfdcPrdLine.mps_id }}, MPS Date: {{sfdcPrdLine.mps_date}}; QTY: {{sfdcPrdLine.quantity}}
            </b-form-checkbox>
          </b-form-group>
        </div>
      </div>

      <div v-if="customizationPnWarning !== null" class="row mb-2">
        <div class="col-12">
          <b class="text-danger pl-1">{{customizationPnWarning}}</b>
        </div>
      </div>

    </b-modal>
    <!-- #endregion-->
    <!-- warning modal for sync pn, if PN format is not expected-->
    <b-modal centered :ok-title="validatePnFormat.okTitle" @ok="validatePrdLineForSync() && saveCustomizationPn(customizationPnModalData)"
             :cancel-title="validatePnFormat.cancelTitle"
             :ok-variant="validatePnFormat.variant"
             :title-class="[`text-${validatePnFormat.variant || 'primary'}`]"
             ref="ValidatePnFormatModal" :title="validatePnFormat.title"
             button-size="sm">
      <div>
        <p><b>{{ validatePnFormat.message1 }}</b></p>
        <p>{{ validatePnFormat.message2 }}</p>
        <p>{{ validatePnFormat.message2_a }}</p>
        <p>{{ validatePnFormat.message2_b }}</p>
        <p>{{ validatePnFormat.message2_c }}</p>
      </div>
      </br>
      <div><b>{{ validatePnFormat.message3 }}</b></div>
    </b-modal>
    <!-- #endregion-->
        <b-modal centered
             ok-title="Sync"
             cancel-title="Cancel"
             @ok="synvFtieToSf"
             ref="syncFtieOnlyModal"
             title="Sync FTIE"
             button-size="sm">
      <div>
        <p><b>Please confirm that you want to synchronize FTIE#{{ftieId}} to SalesForce</b></p>

      </div>
      <div v-if="syncFtieItem !=null && syncFtieItem.sfdc_sync_grouping_set!== null && _.size(syncFtieItem.sfdc_sync_grouping_set)>1">
        <div class="border-bottom" style="padding-top: 1rem;"></div>
        <br />
        <div class="row mb-2">
          <div class="col-12">
            <span class="text-danger pl-1">There are multiple product line in SFDC shared the same standard SKU ID and Qty. Please confirm if need to sync them all.</span>
          </div>
        </div>
        <br />
        <div class="row mb-2" style="margin:1.5px">
          <b-form-group>
            <b-form-checkbox v-if="syncFtieItem !=null" v-for="sfdcPrdLine in syncFtieItem.sfdc_sync_grouping_set"
                             v-model="selectedMpsIdToSyncFtie"
                             :key="sfdcPrdLine.mps_id"
                             :value="sfdcPrdLine.mps_id"
                             name="flavour-3a"
                             stack>
              <!--                             @change="setPnWarning"-->
              ID: {{ sfdcPrdLine.mps_id }}, MPS Date: {{sfdcPrdLine.mps_date}}; QTY: {{sfdcPrdLine.quantity}}
            </b-form-checkbox>
          </b-form-group>
        </div>
      </div>
    </b-modal>
    <!-- #endregion Modal-->
  </div>
</template>

<script>
  export default {
    name: 'sfdc-prd-line',
    props: {
      prop_sfdc_page_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_request_detail_id: {
        default: null
      },
      prop_basic_info: {
        default: null
      },
    },
    data: function () {
      return {
        isRouterAlive: true,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        sfdcProducts: null,
        sfdcProductsOriginal: null,
        fixModel: true,
        fixCustomizationPn: "Customization",
        basicInfo: null,
        loginUser: null,
        userSites: null,
        actionEnable: false,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        ftieId: null,
        createBy: null,
        realSkuNo: null,
        autopilotOptions: [{ text: 'No', value: 'No' }, { text: 'Yes', value: 'Yes' }],
        searching: false,
        maintianPnHint: '* Please maintain PN',
        noneSelectedHint: '',
        categoryWeightMappingDic:
        {
          'SW Related': 0,
          'SW Related (Outsource Required)': 2,
          'Labelling': 0,
          'Installation Service': 0,
          'Branding': 0,
          'Local Certificate only': 2,
          'Global Certificate': 2,
          'Create New Accessory': 4,
          'MIT Key Components': 0,
          'Component Removed (Strategy Functional Removal)': 0,
          'Component Removed (Create New PN/BOM Only)': 3,
          'Component Removed (Conduct C-Test Required)': 4,
        },
        selectedCategory: [],
        displayCustomWeight: '',
        displayCustomFinalResult: '',
        displayCustomFinalResultShort: '',
        customCategoryList: [],
        customlevelModalData: {
          shippedPnToSync: '',
          mpsPnToSync: '',
          mpsIdList: null,
          mpsId: null,
          standardSkuId: null,
          oldCustomLevelList: null,
          newCustomLevelList: null,
        },
        uniqueCompoPnToAdd: '',
        updateErrMsg: null,
        uniquePnModalData: {
          uniquePnList: [],
          shippedPnToSync: '',
          mpsPnToSync: '',
          mpsIdList: null,
          mpsId: null,
          standardSkuId: null,
          optyId: null,
          optyName: null,
          errorMsg: null,
        },
        uniquePnTableFields: [
          { key: 'critical_pn', label: 'Unique P/N', thClass: 'align-middle', sortable: true },
          { key: 'description', label: 'Description', thClass: 'align-middle', sortable: true },
          //key: mps_id
          {
            key: 'action', label: 'Action',
            thClass: 'align-middle',
            thStyle: {
              display: 'none'
            },
            sortable: false
          },
        ],
        selectedMpsIdToSync: [],
        selectedMpsIdToSyncFtie: [],
        reloadBusy: false,
        processedIndex: [],
        customizationPnWarning: null,
        customizationPnModalData: {
          itemObj: null,

          shippedPnToSyncNew: null,
          shippedPnToSync: null,

          mpsPnToSyncNew: null,
          mpsPnToSync: null,
          sfdcPrdLines:null,
          mpsIdList: null,
          mpsId: null,

          customSkuId: null,
          refSkuId: null,
          optyName: null,
          optyId: null,
          esNumber: null,
          saTickAutopilotFlag: null,
          confirmAutopilotReq: null, //        sa_selected_autopilot: null,
          mpsPnStd: null,
          shipPnStd: null,
          nre_list: [],
          nre_id: null
        },
        tempPnTag:'(Invalid PN Format | Local Only)',
        validatePnFormat: {
          title: 'Customization Part Number Format',
          titleClass: null,
          size: null,
          buttonSize: null,
          okVariant: null,
          okTitle: 'Confirm (proceed with update)',
          cancelTitle: 'Cancel (return to edit)',
          // action: 'auto_approve',
          message1: 'Confirm Temporary Part Number Update',
          message2: 'You are about to update a Part Number that does not follow Getac’s standard naming rules.To prevent errors in ERP OP and Salesforce processes:',
          message2_a: '1. This ineligible PN value will only remain/store in FTIE.',
          message2_b: '2. It will NOT update to ERP SKU PN mapping table.',
          message2_c: '3. The ineligible PN value will be replaced with NULL before updating to Salesforce.',
          message3: 'Confirm you understand these consequences before proceeding.',
          messageError: 'Please reach out to System Adminstrators with screnshot and necessary info for the trouble shooting!',
          state: false,
          variant: 'primary',
          invalidFeedback: 'Please contact system admin for this error.'
        },
        syncFtieItem: null,
        checkAll: true
      }
    },
    computed: {
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      },
      autopilotFlagState() {
        // console.log("autopilotFlagState ==");
        // console.log(Boolean((_.get(this.basicInfo, 'autopilot_flag_by_sa', null) == null && _.get(this.customizationPnModalData, 'confirmAutopilotReq', null) == 'No') || _.get(this.customizationPnModalData, 'confirmAutopilotReq', null) == _.get(this.basicInfo, 'autopilot_flag_by_sa', null)));
        return Boolean((_.get(this.basicInfo, 'autopilot_flag_by_sa', null) == null && _.get(this.customizationPnModalData, 'confirmAutopilotReq', null) == 'No') || _.get(this.customizationPnModalData, 'confirmAutopilotReq', null) == _.get(this.basicInfo, 'autopilot_flag_by_sa', null))
      },
      hasOrNotTickAutopilot() {
        let self = this;
        if (_.get(this.basicInfo, 'autopilot_flag_by_sa', null) == 'Yes') {
          return "has"
        } else{
          return "has not"
        }
      },
      sfdcProductFields() {
        let self= this;
        let fields = [
            { key: 'model_name', label: 'Model', thClass: 'align-middle', sortable: true },
            { key: 'product_type', label: 'Product Type', thClass: 'align-middle', sortable: true },
            { key: 'standard_sku_id', label: 'Standard SKU ID', thClass: 'align-middle', sortable: true },
            { key: 'mps_date', label: 'MPS Date', thClass: 'align-middle', sortable: true },
            { key: 'mps_status', label: 'MPS Status', thClass: 'align-middle', sortable: true },
            {
              key: 'standard_pn', label: 'Standard PN',
              thClass: 'align-middle',
              tdClass: 'min-w-187',
              sortable: true
            },
            {
              key: 'sfdc_cust_pn_set', label: 'SF Customization PN',
              thClass: 'align-middle',
              tdClass: 'min-w-187',
              sortable: true
            },
            {
              key: 'mps_ftie_id', label: 'SF FTIE',
              thClass: 'align-middle text-nowrap',
              // tdClass: 'min-w-187',
              sortable: true
            },
            { key: 'quantity', label: 'Qty', thClass: 'align-middle', sortable: true },
            { key: 'last_edit_date', label: 'Last Edit Date', thClass: 'align-middle', sortable: true }
        ];
        if(self.userSites!==null && self.userSites.includes('Getac')){
          fields.splice(5, 0,
            {
              key: 'custom_level_result', label: 'Custom Level', thClass: 'align-middle',
              thStyle: { width: "10%" },
              tdClass: 'min-w-187',
              sortable: true
            },
            {
              key: 'unique_pn', label: 'Unique PN', thClass: 'align-middle',
              tdClass: 'min-w-187',
              sortable: true
            },
            {
              key: 'customization_pn_set', label: 'Customization PN',
              thClass: 'align-middle',
              tdClass: 'min-w-187',
              sortable: true
            },
          )
        }
        return fields;
      },
    },
    watch: {
      selectedMpsIdToSync(newVal) {
        let self = this;
        self.checkAll = newVal.length === self.customizationPnModalData.sfdcPrdLines.length;
      }
    },
    created() {
      let self = this;
      self.sfdcProducts = self.prop_sfdc_page_obj;
      self.sfdcProductsOriginal = self.prop_sfdc_page_obj;
      self.basicInfo = self.prop_basic_info;
      self.fixModelforPrdLine(true);
      self.createBy = _.get(self.basicInfo, 'gtc_owner', null);
      self.userSites = self.prop_user_sites;
      self.loginUser = self.prop_user;
      self.request_detail_id = self.prop_request_detail_id;
      self.actionEnable = self.checkActionEnable();
      self.ftieId =_.get(self.basicInfo, 'ftie_id', null);
      //console.log("SFDC Copo actionEnable:");
      //console.log(self.actionEnable);
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },

      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        if (self.loginUser === 'power') {
          return true;
        }

        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }
        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1 || _.indexOf(self.userRoles, 'ES_PM') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        //login_user_name === ftie_page_obj.gtc_owner || login_user_name === 'power' || (userRoles !== null && userRoles.includes('Admin')))
        return false;
      },
      resetUniquePnModalData() {
        let self = this;
        _.set(self.uniquePnModalData, 'uniquePnList', new Array());
        _.set(self.uniquePnModalData, 'shippedPnToSync', '');
        _.set(self.uniquePnModalData, 'mpsPnToSync', '');
        _.set(self.uniquePnModalData, 'mpsIdList', null);
        _.set(self.uniquePnModalData, 'mpsId', null);
        _.set(self.uniquePnModalData, 'standardSkuId', null);
        _.set(self.uniquePnModalData, 'errorMsg', null);
      },

      getMpsIdListByGroupingLine(groupingPrdLine) {
        let self = this;
        //groupingPrdLine refer to data.item.sfdc_sync_grouping_set
        let result = new Array();
        if (groupingPrdLine !== null && _.size(groupingPrdLine) > 0) {
          for (let i = 0; i < _.size(groupingPrdLine); i++) {
            if (_.get(groupingPrdLine[i], 'mps_id', '') !== '' && _.get(groupingPrdLine[i], 'mps_id', '') !== null) {
              result.push(_.get(groupingPrdLine[i], 'mps_id', ''))
            }
          }
        }
        return result;
      },

      fixModelforPrdLine(fixModel) {
        let self = this;
        //console.log("self.sfdcProductsOriginal =");
        //console.log(self.sfdcProductsOriginal);
        // model_name
        if (fixModel === true
          && _.get(self.basicInfo, 'device') !== null
          && self.sfdcProductsOriginal !== null && self.sfdcProductsOriginal.length > 0) {
          let sfdcProductsPolished = _.filter(self.sfdcProductsOriginal, { 'model_name': _.get(self.basicInfo, 'device') });
          //console.log("sfdcProductsPolished = {}");
          //console.log(sfdcProductsPolished);
          self.sfdcProducts = JSON.parse(JSON.stringify(sfdcProductsPolished));
        }
        else {
          self.sfdcProducts = JSON.parse(JSON.stringify(self.sfdcProductsOriginal));
        }
      },
      fixPNforCustomizationType(fixCustomizationPn) {
        let self = this;
        //console.log("self.fixCustomizationPn =");
        //console.log(self.fixCustomizationPn);
      },
      refreshSingleItem(mpsIdList, mpsId, refreshCol) {
        let self = this;
        if (mpsId !== null) {
          let currIndex = _.findIndex(mpsIdList, (e) => {
            return e == mpsId;
          }, 0);
          self.processedIndex.push(currIndex);
          let item = self.sfdcProducts[_.findIndex(self.sfdcProducts, { 'mps_id': mpsId })];
          let requestData = {
            ftie_id: _.get(self.basicInfo, 'ftie_id', null),
            mps_id: _.get(item, 'mps_id', null),
          };
          let result_string = '';
          let result_string_short = '';
          let result_obj = null;
          let jsonResult = null;
          if (refreshCol === 'custom-category' || refreshCol === 'unique-pn') {
            jsonResult = new Array();
          }
          let url = self.$root.baseUrl + '/nre/' + refreshCol + '/reload/'; //refreshCol in ['custom-category', 'unique-pn', 'custom-pn']
            this.$axios
              .post(url, requestData)
              .then(res => {
                let result = res.data;
                //console.log("refreshSingleItem - " + refreshCol + ' Result::');
                //console.log(result);
                if (res.status === 200) {
                  result.reload_object = JSON.parse(result.reload_object);
                  result_obj = result.reload_object;
                  if ('custom-category' === refreshCol) {
                    result_string = result.reload_result;
                    result_string_short = result.reload_result_in_short
                  }
                } else if (result.description == "login") {
                  self.$session.destroy();
                  self.$store.commit('clearToken');
                  var url = self.$root.baseUrl + '/auth/logout/';
                  self.$axios.get(url)
                    .then((res) => {
                      console.log('logout');
                      self.$router.push("/");
                    })
                  window.location = self.frontEndUrlToUse + 'azure-login';
                } else {
                  self.$message.exception('Internal Server Error!');
                  console.log(res.description);
                }
              }, (error) => {
                console.log(error);
                self.$message.exception('Internal Server Error!');
              }).finally(() => {
                if (result_obj !== null && _.size(result_obj) > 0) {
                  jsonResult = JSON.parse(JSON.stringify(result_obj));
                }
                if (refreshCol !== null && refreshCol !== '') {
                  if ('custom-pn' === refreshCol) {
                    _.set(item, 'customization_pn_set', jsonResult);
                    _.set(self.sfdcProducts[_.findIndex(self.sfdcProducts, { 'mps_id': mpsId })], 'customization_pn_set', jsonResult);
                    _.set(self.sfdcProductsOriginal[_.findIndex(self.sfdcProductsOriginal, { 'mps_id': mpsId })], 'customization_pn_set', jsonResult);
                  }
                  else if ('unique-pn' === refreshCol) {
                    _.set(item, 'unique_pn', jsonResult);
                    _.set(self.sfdcProducts[_.findIndex(self.sfdcProducts, { 'mps_id': mpsId })], 'unique_pn', jsonResult);
                    _.set(self.uniquePnModalData, 'uniquePnList', jsonResult);
                    _.set(self.sfdcProductsOriginal[_.findIndex(self.sfdcProductsOriginal, { 'mps_id': mpsId })], 'unique_pn', jsonResult);
                  }
                  else if ('custom-category' === refreshCol) {
                    // --- custom level refresh ---
                    if (self.customCategoryList !== null && _.size(self.customCategoryList) > 0) {
                      let selected = new Array();
                      let oldCustomLevelWithWeightList = new Array();
                      _.set(item, 'custom_level_set', jsonResult);
                      _.set(item, 'custom_level_result', result_string);
                      _.set(item, 'custom_level_result_in_short', result_string_short);

                      _.set(self.sfdcProducts[_.findIndex(self.sfdcProducts, { 'mps_id': mpsId })], 'custom_level_set', jsonResult);
                      _.set(self.sfdcProducts[_.findIndex(self.sfdcProducts, { 'mps_id': mpsId })], 'custom_level_result', result_string);
                      _.set(self.sfdcProducts[_.findIndex(self.sfdcProducts, { 'mps_id': mpsId })], 'custom_level_result_in_short', result_string_short);

                      _.set(self.sfdcProductsOriginal[_.findIndex(self.sfdcProductsOriginal, { 'mps_id': mpsId })], 'custom_level_set', jsonResult);
                      _.set(self.sfdcProductsOriginal[_.findIndex(self.sfdcProductsOriginal, { 'mps_id': mpsId })], 'custom_level_result', result_string);
                      _.set(self.sfdcProductsOriginal[_.findIndex(self.sfdcProductsOriginal, { 'mps_id': mpsId })], 'custom_level_result_in_short', result_string_short);

                      for (var i = 0; i < _.size(item.custom_level_set); i++) {
                        selected.push(item.custom_level_set[i].description);
                        let weight = _.get(self.customCategoryList[_.findIndex(self.customCategoryList, { 'description': item.custom_level_set[i].description })], 'level_weight', 0);
                        oldCustomLevelWithWeightList.push({ 'description': item.custom_level_set[i].description, 'level_weight': weight });
                      }
                      self.selectedCategory = selected;
                      self.displayCustomFinalResult = item.custom_level_result;
                      self.displayCustomFinalResultShort = item.custom_level_result_in_short;
                      self.displayCustomWeight = self.displayCustomFinalResult;
                      _.set(self.customlevelModalData, 'oldCustomLevelList', JSON.parse(JSON.stringify(oldCustomLevelWithWeightList)));
                      _.set(self.customlevelModalData, 'newCustomLevelList', JSON.parse(JSON.stringify(oldCustomLevelWithWeightList)));
                    }
                    // --- endregion
                  }

                  //console.log("self.sfdcProducts[index by mps_id] refresh result!!");
                  //console.log(self.sfdcProducts[_.findIndex(self.sfdcProducts, { 'mps_id': mpsId })]);
                }
                //console.log("mpsIdList[_.size(mpsIdList) - 1] = " + mpsIdList[_.size(mpsIdList) - 1]);
                //console.log("current mpsId = " + mpsId);
                if (mpsIdList[_.size(mpsIdList) - 1] === mpsId) {
                  return;
                } else {
                  let currIndex = _.findIndex(mpsIdList, (e) => {
                    return e == mpsId;
                  }, 0);
                  self.refreshSingleItem(mpsIdList, mpsIdList[currIndex+1], refreshCol)
                }
              });
        }
      },

      /* region: UNIQUE PN */
      showEditUniquePnModal(item) {
        let self = this;
        self.resetUniquePnModalData();
        let chosen_shipped_pn = '';
        let chosen_mps_pn = '';
        let standard_sku_id = item.standard_sku_id;
        let opty_id = item.opty_id
        let opty_name = _.get(self.basicInfo, 'opty_name', null)
        let mps_id_list = self.getMpsIdListByGroupingLine(_.get(item, 'sfdc_sync_grouping_set', null));
        let mps_id = null;
        self.uniqueCompoPnToAdd = '';
        _.set(self.uniquePnModalData, 'errorMsg', null);
        self.updateErrMsg = null;
        if (item && item.mps_id) {
          mps_id = _.get(item, 'mps_id', mps_id);
        }

        if (item && item.customization_pn_set && _.size(item.customization_pn_set) > 0) {
          chosen_shipped_pn = _.get(item.customization_pn_set[0], 'ship_pn', '');
          chosen_mps_pn = _.get(item.customization_pn_set[0], 'mps_pn', '');
        }
        if (item !== null && item.unique_pn !== null && item.unique_pn !== '' && _.size(item.unique_pn) > 0) {
          _.set(self.uniquePnModalData, 'uniquePnList', JSON.parse(JSON.stringify(item.unique_pn)));
          //self.uniquePnModalData.uniquePnList = JSON.parse(JSON.stringify(item.unique_pn));
        }
        _.set(self.uniquePnModalData, 'shippedPnToSync', chosen_shipped_pn);
        _.set(self.uniquePnModalData, 'mpsPnToSync', chosen_mps_pn);
        _.set(self.uniquePnModalData, 'standardSkuId', standard_sku_id);
        _.set(self.uniquePnModalData, 'optyId', opty_id);
        _.set(self.uniquePnModalData, 'optyName', opty_name);
        _.set(self.uniquePnModalData, 'mpsIdList', mps_id_list);
        _.set(self.uniquePnModalData, 'mpsId', mps_id);
        self.$refs['uniquePnModal'].show();

      },
      /* endregion */

      /* region: Add Unique PN*/
      addUniquePn(modalItem) {
        let self = this;
        let inputInfo = {
          ftie_id: _.get(self.basicInfo, 'ftie_id', null),
          ship_pn: _.get(modalItem, 'shippedPnToSync', null),
          mps_pn: _.get(modalItem, 'mpsPnToSync', null),
          mps_id_list: _.get(modalItem, 'mpsIdList', null), //[]
          unique_pn_list: _.trim(self.uniqueCompoPnToAdd),
          standard_sku_id: _.get(modalItem, 'standardSkuId', null),
          create_by: self.createBy,
          opty_id: _.get(modalItem, 'optyId', null),
          opty_name: _.get(modalItem, 'optyName', null),
        };
        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
          input_info: inputInfo
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let result_obj = null;
        let result_string = '';
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/nre/unique-pn/insert/', requestData, params)
          .then(res => {
            let result = res.data;
            //console.log("addUniquePn:result");
            //console.log(result);
            result_string = result.error_msg
            _.set(self.uniquePnModalData, 'errorMsg', result_string);
            self.updateErrMsg = result_string;
            if (self.updateErrMsg === '') {
              self.updateErrMsg = null;
            }
            if (res.status === 200) {
              result.insert_success = JSON.parse(result.insert_success);
              result_obj = result.insert_success

            } else if (result.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          }).finally(() => {
            eventHub.$emit('loading', false);
            if (_.get(modalItem, 'mpsIdList', null) !== null && _.size(_.get(modalItem, 'mpsIdList', new Array())) > 0) {
              let mpsIdTmp = _.get(modalItem, 'mpsIdList', null)[0];
              self.processedIndex = new Array();
              self.refreshSingleItem(_.get(modalItem, 'mpsIdList', null), mpsIdTmp, 'unique-pn');
            }
          });

      },
      /* endregion*/
      /* region: Delete Unique PN */
      deleteUniquePn(modalItem, unique_pn) {
        let self = this;

        let inputInfo = {
          ftie_id: _.get(self.basicInfo, 'ftie_id', null),
          mps_id_list: _.get(modalItem, 'mpsIdList', null), //[]
          unique_pn: _.trim(unique_pn),
        };
        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
          input_info: inputInfo
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        let result_obj = null;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/nre/unique-pn/delete/', requestData, params)
          .then(res => {
            let result = res.data;
            console.log("deleteUniquePn:result");
            //console.log(res);
            if (res.status === 200) {
              result.update_success = JSON.parse(result.delete_success);
              result_obj = result.delete_success;
            } else if (result.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          }).finally(() => {
            eventHub.$emit('loading', false);
            if (_.get(modalItem, 'mpsIdList', null) !== null && _.size(_.get(modalItem, 'mpsIdList', new Array())) > 0) {
              let mpsIdTmp = _.get(modalItem, 'mpsIdList', null)[0];
              self.processedIndex = new Array();
              self.refreshSingleItem(_.get(modalItem, 'mpsIdList', null), mpsIdTmp, 'unique-pn');
            }
          });
      },
      /* endregion */

      /* region: GET CUSTOM LEVEL LIST*/
      getCustomCategoryList(item) {
        //eventHub.$emit('loading', true);
        let self = this;
        let chosen_shipped_pn = '';
        let chosen_mps_pn = '';
        let mps_id_list = self.getMpsIdListByGroupingLine(_.get(item, 'sfdc_sync_grouping_set', null));
        let mps_id = null;

        if (item && item.mps_id) {
          mps_id = _.get(item, 'mps_id', mps_id);
          console.log("getCustomCategoryList mps_id:" + mps_id);
        }
        if (item && item.customization_pn_set && _.size(item.customization_pn_set) > 0) {
          chosen_shipped_pn = _.get(item.customization_pn_set[0], 'ship_pn', '');
          chosen_mps_pn = _.get(item.customization_pn_set[0], 'mps_pn', '');
        }

        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
        };
        let result_obj = null;
        this.$axios
          .post(self.$root.baseUrl + '/nre/custom-category/list/', requestData)
          .then(res => {
            let result = res.data;
            if (res.status === 200) {
              result.custom_category_level_info_list = JSON.parse(result.custom_category_level_info_list);
              result_obj = result.custom_category_level_info_list;
            } else if (result.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          }).finally(() => {
            //eventHub.$emit('loading', false);
            //self.$refs['sfdcSyncModal'].show();
            self.customCategoryList = result_obj;
            //console.log("chosen_shipped_pn = " + chosen_shipped_pn);
            _.set(self.customlevelModalData, 'shippedPnToSync', chosen_shipped_pn);
            _.set(self.customlevelModalData, 'mpsPnToSync', chosen_mps_pn);
            _.set(self.customlevelModalData, 'mpsIdList', mps_id_list);
            _.set(self.customlevelModalData, 'mpsId', mps_id);
            _.set(self.customlevelModalData, 'standardSkuId', _.get(item, 'standard_sku_id', null));
            let selected = new Array();
            let oldCustomLevelWithWeightList = new Array()
            eventHub.$emit('loading', false);
            if (self.customCategoryList !== null && _.size(self.customCategoryList) > 0
              && item.custom_level_set !== null && _.size(item.custom_level_set) > 0) {

              for (var i = 0; i < _.size(item.custom_level_set); i++) {
                selected.push(item.custom_level_set[i].description);
                let weight = _.get(self.customCategoryList[_.findIndex(self.customCategoryList, { 'description': item.custom_level_set[i].description })], 'level_weight', 0);
                oldCustomLevelWithWeightList.push({ 'description': item.custom_level_set[i].description, 'level_weight': weight });
              }
              self.selectedCategory = selected;
              self.displayCustomFinalResult = item.custom_level_result;
              self.displayCustomFinalResultShort = item.custom_level_result_in_short;
              self.displayCustomWeight = self.displayCustomFinalResult;
              _.set(self.customlevelModalData, 'oldCustomLevelList', JSON.parse(JSON.stringify(oldCustomLevelWithWeightList)));
              _.set(self.customlevelModalData, 'newCustomLevelList', JSON.parse(JSON.stringify(oldCustomLevelWithWeightList)));
            }
            else {
              self.selectedCategory = selected;
              _.set(self.customlevelModalData, 'oldCustomLevelList', oldCustomLevelWithWeightList);
              _.set(self.customlevelModalData, 'newCustomLevelList', oldCustomLevelWithWeightList);
              self.displayCustomFinalResult = '';
              self.displayCustomFinalResultShort = '';
              self.displayCustomWeight = '';
            }
            self.$refs['customLevelModal'].show();
          });
      },
      /* endregion */

      /* region: SAVE CUSTOM LEVEL */
      saveCustomLevel(modalItem) {
        let self = this;
        // custom-category/update/
        let inputInfo = {
          ftie_id: _.get(self.basicInfo, 'ftie_id', null),
          standard_sku_id: _.get(modalItem, 'standardSkuId', null),
          old_custom_levels: _.get(modalItem, 'oldCustomLevelList', null), //[]
          new_custom_levels: _.get(modalItem, 'newCustomLevelList', null), // []
          mps_id_list: _.get(modalItem, 'mpsIdList', null), //[]
          create_by: self.createBy,
          ship_pn: _.get(modalItem, 'shippedPnToSync', null),
          mps_pn: _.get(modalItem, 'mpsPnToSync', null),
        };
        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
          input_info: inputInfo
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        let result_obj = null;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/nre/custom-category/update/', requestData, params)
          .then(res => {
            let result = res.data;
            console.log("saveCustomLevel:result");
            //console.log(res);
            if (res.status === 200) {
              result.update_success = JSON.parse(result.update_success);
              result_obj = result.update_success
            } else if (result.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          }).finally(() => {
            eventHub.$emit('loading', false);
            if (_.get(modalItem, 'mpsIdList', null) !== null && _.size(_.get(modalItem, 'mpsIdList', new Array())) > 0) {
              let mpsIdTmp = _.get(modalItem, 'mpsIdList', null)[0];
              self.processedIndex = new Array();
              self.refreshSingleItem(_.get(modalItem, 'mpsIdList', null), mpsIdTmp, 'custom-category');
            }
          });

      },
      /* enregion */

      /* region: custom PN sync*/
      showCustomPnSyncModal(item) {
        let self = this;
        let chosen_shipped_pn = '';
        let chosen_mps_pn = '';
        let mpsPnStd = '';
        let shipPnStd = '';

        let mps_id_list = self.getMpsIdListByGroupingLine(_.get(item, 'sfdc_sync_grouping_set', null));
        let mps_id = null;
        if (item && item.mps_id) {
          mps_id = _.get(item, 'mps_id', mps_id);
        }

        if (item && item.customization_pn_set && _.size(item.customization_pn_set) > 0) {
          chosen_shipped_pn = _.get(item.customization_pn_set[0], 'ship_pn', '');
          chosen_mps_pn = _.get(item.customization_pn_set[0], 'mps_pn', '');
          _.set(self.customizationPnModalData, 'itemObj', JSON.parse(JSON.stringify(item.customization_pn_set)));
        }

        if (item && item.std_pn_set && _.size(item.std_pn_set) > 0) {
          mpsPnStd = _.get(item.std_pn_set[0], 'ship_pn', '');
          shipPnStd = _.get(item.std_pn_set[0], 'mps_pn', '');
          _.set(self.customizationPnModalData, 'mpsPnStd', mpsPnStd);
          _.set(self.customizationPnModalData, 'shipPnStd', shipPnStd);
        }
        let filterNreList = _.filter(self.basicInfo.nre_list, { 'REF_SKU_ID': _.get(item, 'standard_sku_id', null) })
        if (filterNreList && _.size(filterNreList) > 0) {
          let options = filterNreList.map(x => ({
            text: `${x.REF_SKU_ID} - ${x.NRE_ID}`,
            value: x.NRE_ID 
          }));
          _.set(self.customizationPnModalData, 'nre_list', options);
          _.set(self.customizationPnModalData, 'nre_id', filterNreList[0].NRE_ID);
        }

        _.set(self.customizationPnModalData, 'shippedPnToSync', chosen_shipped_pn);
        _.set(self.customizationPnModalData, 'mpsPnToSync', chosen_mps_pn);
        _.set(self.customizationPnModalData, 'shippedPnToSyncNew', chosen_shipped_pn);
        _.set(self.customizationPnModalData, 'mpsPnToSyncNew', chosen_mps_pn);

        _.set(self.customizationPnModalData, 'sfdcPrdLines', _.get(item, 'sfdc_sync_grouping_set', null));
        _.set(self.customizationPnModalData, 'mpsIdList', mps_id_list);
        _.set(self.customizationPnModalData, 'mpsId', mps_id);

        _.set(self.customizationPnModalData, 'customSkuId', _.get(item, 'custom_sku_id', null)); // [SFDC PRD LINE]item didn't contain custom_sku_id
        _.set(self.customizationPnModalData, 'refSkuId', _.get(item, 'standard_sku_id', null));
        _.set(self.customizationPnModalData, 'optyId', _.get(item, 'opty_id', null));
        _.set(self.customizationPnModalData, 'optyName', _.get(self.basicInfo, 'opty_name', null));
        _.set(self.customizationPnModalData, 'esNumber', _.get(self.basicInfo, 'es_number', null));

        // confirmAutopilotReq
        _.set(self.customizationPnModalData, 'saTickAutopilotFlag', _.get(self.basicInfo, 'autopilot_flag_by_sa', null));
        if (_.get(self.basicInfo, 'autopilot_flag_confirm_by_espm', null) === null
          || (_.get(self.basicInfo, 'autopilot_flag_confirm_by_espm', null) !== 'Yes' && (_.get(self.basicInfo, 'autopilot_flag_confirm_by_espm', null) !== 'No'))) {
          _.set(self.customizationPnModalData, 'confirmAutopilotReq', _.get(self.basicInfo, 'autopilot_flag_by_sa', null));
        } else {
          _.set(self.customizationPnModalData, 'confirmAutopilotReq', _.get(self.basicInfo, 'autopilot_flag_confirm_by_espm', null));
        }


        self.selectedMpsIdToSync = mps_id_list;
        /*
        console.log("self.selectedMpsIdToSync = ");
        console.log(self.selectedMpsIdToSync);
        console.log("self.customizationPnModalData.saTickAutopilotFlag = ");
        console.log(self.customizationPnModalData.saTickAutopilotFlag);
        console.log("self.customizationPnModalData.confirmAutopilotReq = ");
        console.log(self.customizationPnModalData.confirmAutopilotReq);
        */


        self.$refs['customizationPnModal'].show();
      },

      saveCustomizationPn(item) {
        let self = this;
        let syncPnInputInfo = {
          create_by: self.createBy,
          username: self.loginUser,
          create_date: self.$root.getTime(),
          ftie_id: self.ftieId,
          request_detail_id: self.request_detail_id,
          mps_id_list: _.get(item, 'mpsIdList', null),
          mps_id: _.get(item, 'mpsId', null),
          mps_pn: _.get(item, 'mpsPnToSyncNew', null),
          ship_pn: _.get(item, 'shippedPnToSyncNew', null),
          nre_id: _.get(item, 'nre_id', null),
          standard_sku_id: _.get(item, 'refSkuId', null),
          es_number: _.get(self.basicInfo, 'es_number', null),
          opty_id: _.get(item, 'optyId', null),
          action: 'sync',
          sa_tick_autoplot_req: _.get(item, 'saTickAutopilotFlag', null),
          confirm_autoplot_req: _.get(item, 'confirmAutopilotReq', null),
          gro_owner: self.basicInfo.gro_owner
        };
        if (self.selectedMpsIdToSync !== null && self.selectedMpsIdToSync !== '' && _.size(self.selectedMpsIdToSync) > 0) {
          _.set(syncPnInputInfo, 'mps_id_list', self.selectedMpsIdToSync);
          self.customizationPnWarning = null;
        }
        else {
          self.customizationPnWarning = 'Please at least chose one product line to be synced with!';
        }

        if (self.customizationPnWarning === null) {
          let requestData = {
            input_info: JSON.parse(JSON.stringify(syncPnInputInfo)),
          };

          //console.log("saveCustomizationPn requestData=");
          //console.log(requestData);
          const params = {
            token: encodeURI(self.$store.state.token),
            username: encodeURI(self.$store.state.username),
          };
          let result_obj = null;
          eventHub.$emit('loading', true);
          this.$axios
            .post(self.$root.baseUrl + '/nre/custom-pn/sync/', requestData, params)
            .then(res => {
              let result = res.data;
              console.log("saveCustomizationPn:result");
              //console.log(result);
              if (res.status === 200) {
                result.save_success = JSON.parse(result.save_success);
                result_obj = result.save_success
              } else if (result.description == "login") {
                self.$session.destroy();
                self.$store.commit('clearToken');
                var url = self.$root.baseUrl + '/auth/logout/';
                self.$axios.get(url)
                  .then((res) => {
                    console.log('logout');
                    self.$router.push("/");
                  })
                window.location = self.frontEndUrlToUse + 'azure-login';
              } else {
                self.$message.exception('Internal Server Error!');
                console.log(res.description);
              }
            }, (error) => {
              console.log(error);
              self.$message.exception('Internal Server Error!');
            }).finally(() => {
              eventHub.$emit('loading', false);
              if (_.get(item, 'mpsIdList', null) !== null && _.size(_.get(item, 'mpsIdList', new Array())) > 0) {
                let mpsIdTmp = _.get(item, 'mpsIdList', null)[0];
                self.processedIndex = new Array();
                self.refreshSingleItem(_.get(item, 'mpsIdList', null), mpsIdTmp, 'custom-pn');
                self.$nextTick(() => {
                  let target_item = self.sfdcProducts[_.findIndex(self.sfdcProducts, { 'mps_id': mpsIdTmp })];
                  self.showEditUniquePnModal(target_item);
                });
              } else {
                self.$nextTick(() => {
                  let target_item = self.sfdcProducts[_.findIndex(self.sfdcProducts, { 'mps_id': _.get(item, 'mpsId', null) })];
                  self.showEditUniquePnModal(target_item);
                });
              }
            });
        }
      },
      /* endregion */



      validatePrdLineForSync() {
        let self = this;

        if (self.selectedMpsIdToSync !== null && self.selectedMpsIdToSync !== '' && _.size(self.selectedMpsIdToSync) > 0) {
          //self.customizationPnWarning = null;
          return true;
        }
        else {
          //self.customizationPnWarning = 'Please at least chose one product line to be synced with!';
          self.$message.warning('Please at least chose one product line to be synced with!', 'SFDC Sync Warning');
          return false;
        }
      },

      validateNreForSync() {
        let self = this;

        if (self.customizationPnModalData.nre_id !== null) {
          //self.customizationPnWarning = null;
          return true;
        }
        else {
          //self.customizationPnWarning = 'Please at least chose one product line to be synced with!';
          self.$message.warning('Please chose NRE to be synced with!', 'SFDC Sync Warning');
          return false;
        }
      },

      validatePartNumberFormat(customizationPnModalData) {
        let self = this;
        //if (!(_.get(customizationPnModalData, 'mpsPnToSyncNew', '')).startsWith('5262') || (_.get(customizationPnModalData, 'mpsPnToSyncNew', '')).length !== 12 || !(_.get(customizationPnModalData, 'shippedPnToSyncNew', '')).startsWith('5262') || (_.get(customizationPnModalData, 'shippedPnToSyncNew', '')).length !== 12)
        if (!self.checkPnEligible(_.get(customizationPnModalData, 'mpsPnToSyncNew', '')) || !self.checkPnEligible(_.get(customizationPnModalData, 'shippedPnToSyncNew', ''))) {
          this.$refs['ValidatePnFormatModal'].show();
          return false;
        }
        //if (!self.validatePnFollowingNamingRule(_.get(customizationPnModalData, 'mpsPnToSyncNew', '')) || !self.validatePnFollowingNamingRule(_.get(customizationPnModalData, 'shippedPnToSyncNew', '')))
        //{
        //  this.$refs['ValidatePnFormatModal'].show();
        //  return false;
        //}
        return true; // Valid PN
      },

      // --- NEW METHOD TO VALIDATE PN ----
      checkPnEligible(pnValue = null) {
        let validationMsg = '';
        let result = false;
        try {
          if (pnValue === null || pnValue === '') {
            validationMsg += `check_pn_eligible False. pn_value = ${pnValue}`;
            result = false;
          } else if (
            pnValue !== null &&
            (pnValue.length > 20 ||
              pnValue.includes('<') ||
              pnValue.includes('>') ||
              pnValue.includes('(') ||
              pnValue.includes(')'))
          ) {
            validationMsg += `check_pn_eligible False. detect and ban_potential_risk pn_value, len(pn_value) > 20 or '<' in pn_value or '>' in pn_value or '(' in pn_value or ')' in pn_value)`;
            result = false;
          } else if (
            pnValue !== null &&
            pnValue.length > 4 &&
            /^[A-Za-z0-9\-\_\.]{1,20}$/.test(pnValue)
          ) {
            // Formal Device PN
            if (
              pnValue.startsWith('5262') ||
              pnValue.startsWith('5433') ||
              pnValue.startsWith('5427') ||
              pnValue.startsWith('5651')
            ) {
              // TBD: Digit Length 12?
              validationMsg += `check_pn_eligible True. pn_value = ${pnValue}, a eligible Device/System PN`;
              result = true;
            }
            // FOR accessory?
            else if (
              pnValue.startsWith('5413') ||
              pnValue.startsWith('5400')
            ) {
              validationMsg += `check_pn_eligible True. pn_value = ${pnValue}, a eligible Accessory PN`;
              result = true;
            } else {
              validationMsg += `check_pn_eligible False. pn_value = ${pnValue} not match the starting pattern`;
              result = false;
            }
          } else {
            validationMsg += `check_pn_eligible False. pn_value = ${pnValue} not match the pattern`;
            result = false;
          }

          console.info(`check_pn_eligible, validation_msg = ${validationMsg}, result = ${result}`);
          return result;
        } catch (e) {
          console.info(`Exception in check_pn_eligible pn = ${pnValue}, err=${e.message}`);
          console.info(`check_pn_eligible, validation_msg = ${validationMsg}, result = ${result}`);
          return result;
        }
      },
      // End region

      tickCustomCategory() {
        let self = this;
        if (self.selectedCategory.length === 0) {
          self.displayCustomWeight = 'Not chosen yet';

          let newCustomLevelWithWeightList = new Array();
          _.set(self.customlevelModalData, 'newCustomLevelList', JSON.parse(JSON.stringify(newCustomLevelWithWeightList)));
        }
        else {
          let totalWeight = 0;
          if (self.customCategoryList !== null && _.size(self.customCategoryList) > 0) {
            let newCustomLevelWithWeightList = new Array();
            for (var i = 0; i < self.selectedCategory.length; i++) {
              let weight = _.get(self.customCategoryList[_.findIndex(self.customCategoryList, { 'description': self.selectedCategory[i] })], 'level_weight', 0)
              // let weight = _.get(self.customCategoryList, self.selectedCategory[i], 0);
              newCustomLevelWithWeightList.push({ 'description': self.selectedCategory[i], 'level_weight': weight });
              totalWeight = totalWeight + weight;
            }
            _.set(self.customlevelModalData, 'newCustomLevelList', JSON.parse(JSON.stringify(newCustomLevelWithWeightList)));

            let tmp = (self.selectedCategory.length).toString()
              + ' Selected, '
              + 'Weight ' + totalWeight.toString();

            self.displayCustomWeight = tmp//'Weight: ' + totalWeight.toString;
          }
          else {
            self.displayCustomWeight = 'Detect error, please contact system admin!'
          }
        }
      },
      showSyncFtieOnlyModal(item) {
        let self = this;
        self.syncFtieItem = item;
        self.$refs['syncFtieOnlyModal'].show();
        return true; // Valid PN
      },
      synvFtieToSf() {
        let self = this;
        let mps_id_list = [];
        if (_.size(self.syncFtieItem.sfdc_sync_grouping_set)>1){
          mps_id_list = self.selectedMpsIdToSyncFtie;
        }else{
          mps_id_list = [self.syncFtieItem.mps_id];
        }
        let requestData = {
          ftie_id: self.ftieId,
          mps_id_list: mps_id_list
        };
        if (mps_id_list.length <1) {
          self.$message.warning('Please at least chose one product line to be synced with!', 'SFDC Sync Warning');
          return false;
        }
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let result_obj = null;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/nre/ftie/sync/', requestData, params)
          .then(res => {
            let result = res.data;
            if (res.status === 200) {
              result.save_success = JSON.parse(result.save_success);
              result_obj = result.save_success
            } else if (result.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          }).finally(() => {
            eventHub.$emit('loading', false);
            self.syncFtieItem = null;
            self.selectedMpsIdToSyncFtie= [];
            self.$emit('refreshPrdLine');
          });
      },
      onCheckAllChange(checked) {
        let self = this;
        self.selectedMpsIdToSync = checked
          ? self.customizationPnModalData.sfdcPrdLines.map(o => o.mps_id) // 全選
          : [];                             // 全不選
      }
      /* ENDregion: TODO */
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework-sfdc/SfdcPrdLineSync.vue